var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeparture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 320 297",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 148.5C316.5 228.34 246.683 293.5 160 293.5C73.317 293.5 3.5 228.34 3.5 148.5C3.5 68.66 73.317 3.5 160 3.5C246.683 3.5 316.5 68.66 316.5 148.5Z",
    stroke: "black",
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.104 230L147.226 195.553H86.879L76.001 230H45.18L103.973 53.88H131.427L190.479 230H158.104ZM103.714 141.681L95.685 167.063H138.161L130.132 141.681L117.182 97.133L103.714 141.681Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.01 154.01C305.33 150.691 305.33 145.309 302.01 141.99L247.917 87.8959C244.597 84.5765 239.215 84.5765 235.896 87.8959C232.576 91.2154 232.576 96.5973 235.896 99.9167L283.979 148L235.896 196.083C232.576 199.403 232.576 204.785 235.896 208.104C239.215 211.424 244.597 211.424 247.917 208.104L302.01 154.01ZM176 156.5H296V139.5H176V156.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeparture);
export default __webpack_public_path__ + "static/media/departure.3eb80c4856559fa07fad969c7dcac3d9.svg";
export { ForwardRef as ReactComponent };